(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[603],{

/***/ 35243:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(89905);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_shimmer__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(92042);
/* harmony import */ var _layouts_home__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91511);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72287);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(25934);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(18716);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92432);
/* harmony import */ var next_urql__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(61325);
/* harmony import */ var _utils_storage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44920);
/* harmony import */ var _graphql_queries_home_query__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74508);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86501);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_10__);

















var Search = function(props) {
    var ref, ref1, ref2;
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (props.refreshPage) {
            react_hot_toast__WEBPACK_IMPORTED_MODULE_9__/* ["default"].error */ .ZP.error(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "toast",
                children: "Your session has expired."
            }), {
                duration: 10000
            });
            setTimeout(function() {
                window.location.reload();
            }, 2000);
        }
    }, [
        props.refreshPage
    ]);
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(""), 2), searchTerm = ref3[0], setSearchTerm = ref3[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var handleSearch = function() {
        router.push("/search/".concat(searchTerm));
    };
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,urql__WEBPACK_IMPORTED_MODULE_12__/* .useQuery */ .aM)({
        query: _graphql_queries_home_query__WEBPACK_IMPORTED_MODULE_8__/* .GetInawoVendorServiceCategory */ .Tw
    }), 1), categoryResult = ref4[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_10___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Inawo Vendors | Search"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: "Inawo Vendors | Search"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Inawo Vendors Search"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full pt-8 flex justify-start items-center gap-2 text-inawo-black",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "p-1.5 bg-transparent transition hover:bg-gray-50 rounded-md",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        iconName: "arrowLeft"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "uppercase tracking-widest font-light font-sfpro text-base xs:text-lg",
                                children: "Search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "bg-white focus-within:ring-4 focus-within:ring-inawo-green/50 transition text-inawo-black pl-4 pr-2 py-2 font-sfpro my-5 flex justify-start items-center rounded-xl",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "text",
                                placeholder: "Search vendors",
                                className: "p-0 m-0 border-0 font-sfpro font-light placeholder:font-light focus:ring-0 flex-1",
                                onChange: function(e) {
                                    return setSearchTerm(e.target.value);
                                },
                                onKeyDown: function(e) {
                                    if (e.key === "Enter") {
                                        handleSearch();
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                onClick: function() {
                                    return handleSearch();
                                },
                                className: "cursor-pointer p-1.5 rounded-md bg-transparent hover:bg-gray-100 transition",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    iconName: "search"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-5 font-sfpro text-lg sm:text-xl",
                        children: "Browse Vendors"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full grid grid-cols-245 gap-6",
                        children: categoryResult.fetching ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}) : ((ref = categoryResult.error) === null || ref === void 0 ? void 0 : ref.message) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: "An error occured"
                        }) : !!((ref1 = categoryResult.data) === null || ref1 === void 0 ? void 0 : ref1.getInawoVendorServiceCategory) && ((ref2 = categoryResult.data) === null || ref2 === void 0 ? void 0 : ref2.getInawoVendorServiceCategory.map(function(item) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: "/categories/".concat(item === null || item === void 0 ? void 0 : item.id),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    className: "p-6 bg-[#057C68] relative h-48 rounded-2xl overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_13__/* .motion.div */ .E.div, {
                                            initial: {
                                                scale: 1
                                            },
                                            whileHover: {
                                                scale: 1.1
                                            },
                                            className: "absolute z-[0] brightness-[0.8] right-0 bottom-0 top-0 left-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                src: item === null || item === void 0 ? void 0 : item.Images[0],
                                                alt: item === null || item === void 0 ? void 0 : item.Name,
                                                layout: "fill",
                                                blurDataURL: (0,_utils_shimmer__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(400, 400),
                                                quality: 75,
                                                placeholder: "blur",
                                                priority: true,
                                                sizes: "30vw",
                                                objectFit: "cover",
                                                objectPosition: "center"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "font-sfpro absolute text-white z-[2] text-lg sm:text-xl",
                                            children: item === null || item === void 0 ? void 0 : item.Name
                                        })
                                    ]
                                })
                            }, (0,uuid__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)());
                        }))
                    })
                ]
            })
        ]
    });
};
Search.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_home__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,next_urql__WEBPACK_IMPORTED_MODULE_16__/* .withUrqlClient */ .X)(function(_ssr) {
    return {
        url: "https://production.inawo.live/query",
        requestPolicy: "cache-and-network",
        fetchOptions: function() {
            return {
                headers: {
                    "x-user-token": (0,_utils_storage__WEBPACK_IMPORTED_MODULE_7__/* .getAccessCookie */ .tN)() ? "".concat((0,_utils_storage__WEBPACK_IMPORTED_MODULE_7__/* .getAccessCookie */ .tN)()) : ""
                }
            };
        }
    };
}, {
    ssr: false
})(Search));


/***/ }),

/***/ 41411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ Stack; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25934);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72287);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18716);







var Stack = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var active = props.name.toLowerCase() === "home" ? router.pathname === "/" : router.pathname.includes(props.name.toLowerCase());
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
        passHref: true,
        href: props.link,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.a */ .E.a, {
            initial: {
                scale: 1
            },
            whileHover: {
                scale: 1.05
            },
            className: "flex flex-col justify-center items-center ",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-9 w-9 flex justify-center items-center",
                    children: active ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        iconName: props.iconNameActive
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        iconName: props.iconNameInactive
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "font-sfpro text-xs xs:text-sm ".concat(active ? "text-inawo-grey-500 font-semibold" : "text-inawo-black font-light"),
                    children: props.name
                })
            ]
        })
    });
};
var Stacklist = [
    {
        name: "Home",
        link: "/",
        iconNameInactive: "home",
        iconNameActive: "homeActive"
    },
    {
        name: "Search",
        link: "/search",
        iconNameInactive: "search",
        iconNameActive: "searchActive"
    },
    {
        name: "Interests",
        link: "/interests",
        iconNameInactive: "interest",
        iconNameActive: "interestActive"
    },
    {
        name: "Vendors",
        link: "/vendors",
        iconNameInactive: "vendors",
        iconNameActive: "vendorsActive"
    }, 
];
var FloatingBarHome = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "fixed bg-white w-full px-6 py-2 bottom-0 left-0 right-0 z-10 flex justify-center items-center gap-8 sm:gap-12",
        children: Stacklist.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Stack, {
                name: item.name,
                link: item.link,
                iconNameActive: item.iconNameActive,
                iconNameInactive: item.iconNameInactive
            }, (0,uuid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)());
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FloatingBarHome);


/***/ }),

/***/ 74508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J3": function() { return /* binding */ GetVendorServiceByCategory; },
/* harmony export */   "Pz": function() { return /* binding */ GetFeaturedVendorServices; },
/* harmony export */   "Tw": function() { return /* binding */ GetInawoVendorServiceCategory; },
/* harmony export */   "n5": function() { return /* binding */ User; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26997);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetInawoVendorServiceCategory {\n    getInawoVendorServiceCategory {\n      id\n      Name\n      Description\n      Images\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetVendorServiceByCategory(\n    $vendorServiceCategoryId: UUID!\n    $page: Int\n    $pageSize: Int\n  ) {\n    getVendorServiceByCategory(\n      vendorServiceCategoryId: $vendorServiceCategoryId\n    ) {\n      id\n      interests\n      vendors_id\n      price {\n        currency\n        amount\n      }\n      vendor_service_category_id\n      category {\n        id\n        Name\n      }\n      service_name\n      pinned\n      description\n      phone_number\n      rating\n      email\n      address\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_id\n        vendor_service_category_id\n        media\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetFeaturedVendorServices($page: Int, $pageSize: Int) {\n    getFeaturedVendorServices {\n      id\n      vendors_id\n      vendor_service_category_id\n      service_name\n      pinned\n      category {\n        Name\n      }\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        media\n        name\n        vendor_service_id\n        vendors_id\n        vendor_service_category_id\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query User {\n    user {\n      id\n      image\n      email\n      phone_number\n      first_name\n      last_name\n      title\n      uuid\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var GetInawoVendorServiceCategory = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var GetVendorServiceByCategory = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var GetFeaturedVendorServices = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var User = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());


/***/ }),

/***/ 91511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_floating_bar_home__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41411);
/* harmony import */ var _utils_storage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44920);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86501);






var HomeLayout = function(props) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), show = ref[0], setShow = ref[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        setShow(true);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hot_toast__WEBPACK_IMPORTED_MODULE_4__/* .Toaster */ .x7, {
                position: "bottom-center",
                reverseOrder: true,
                containerStyle: {
                    zIndex: "2147483647",
                    isolation: "isolate",
                    transformStyle: "preserve-3d",
                    transform: "translateZ(1000px)",
                    bottom: 90
                },
                toastOptions: {
                    duration: 2000,
                    success: {
                        style: {
                            background: "#376C65",
                            border: "0.5px dashed #376C65",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "20px 50px",
                            fontFamily: "SF Pro Text",
                            fontStyle: "normal",
                            fontWeight: "600",
                            fontSize: "12px",
                            textAlign: "center",
                            color: "#fff",
                            borderRadius: "15px",
                            zIndex: "2147483647",
                            isolation: "isolate",
                            transformStyle: "preserve-3d",
                            transform: "trasnslateZ(1000px)"
                        }
                    },
                    error: {
                        style: {
                            background: "#6C3737",
                            border: "0.5px dashed #6C3737",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "12px 8px",
                            fontFamily: "SF Pro Text",
                            fontStyle: "normal",
                            fontWeight: "400",
                            fontSize: "12px",
                            lineHeight: "19px",
                            textAlign: "center",
                            color: "#fff",
                            borderRadius: "15px",
                            zIndex: "2147483647",
                            isolation: "isolate",
                            transformStyle: "preserve-3d",
                            transform: "trasnslateZ(1000px)"
                        }
                    }
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "z-[0] w-full relative overflow-x-hidden bg-white",
                children: [
                    show && (0,_utils_storage__WEBPACK_IMPORTED_MODULE_3__/* .hasAccessCookie */ .rh)() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_floating_bar_home__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "z-[-1] bg-inawo-bg-green-top-bg w-screen fixed top-0 h-1/3"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-[1300px] mx-auto z-[3] pb-24 px-4 md:px-8 flex flex-col justify-start min-h-full items-center gap-1",
                        children: props.children
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "z-[-1] bg-inawo-bg-grey-bottom-bottom-bg w-screen fixed bottom-0 h-1/5"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HomeLayout);


/***/ }),

/***/ 92042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports shimmer, toBase64 */
var shimmer = function(w, h) {
    return '\n<svg width="'.concat(w, '" height="').concat(h, '" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n  <defs>\n    <linearGradient id="g">\n      <stop stop-color="#333" offset="20%" />\n      <stop stop-color="#222" offset="50%" />\n      <stop stop-color="#333" offset="70%" />\n    </linearGradient>\n  </defs>\n  <rect width="').concat(w, '" height="').concat(h, '" fill="#333" />\n  <rect id="r" width="').concat(w, '" height="').concat(h, '" fill="url(#g)" />\n  <animate xlink:href="#r" attributeName="x" from="-').concat(w, '" to="').concat(w, '" dur="1s" repeatCount="indefinite"  />\n</svg>');
};
var toBase64 = function(str) {
    return  false ? 0 : window.btoa(str);
};
var blurDataUrl = function(w, h) {
    return "data:image/svg+xml;base64,".concat(toBase64(shimmer(w, h)));
};
/* harmony default export */ __webpack_exports__["ZP"] = (blurDataUrl);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [379,88,655,675,237,774,888,377], function() { return __webpack_exec__(35243); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);